<template>
<div>
    <nav id="tab-nav">
        <span class="tablink">Websites</span>
        <!-- <span class="tablink">Applications</span> -->
        <span class="tablink">Graphisme</span>
        <!-- <span class="tablink">Web Marketing</span> -->
        <!-- <span class="tablink">Référencement</span> -->
        <span class="tablink">Visite 360°</span>
    </nav>
    <div id="tab-contents">
        <div class="tab">
            <div class="tab-l-content">
                <img src="@/assets/images/websites.jpg" alt="">
            </div>
            <div class="tab-r-content">
                <p>Nous vous proposons de nombreuses solutions pour mettre en avant vos contenus. Du simple site vitrine au magasin en ligne, nous développons avec les meilleurs outils afin de vous apporter l'autonomie dans la gestion de votre contenu web.</p>
                <p>Le tout en créant un design à votre image et avec une expérience utilisateur pertinante</p>
                <ul>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Solution d'édition de contenu avec Wordpress et/ou VueJS pour votre site vitrine.
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Magasin en ligne ou e-commerce avec prestashop ou wordpress.
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Dévellopement avancé, sur mesure, selon des demandes spécifiques avec diverses solutions.
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Et plus encore...
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="tab">
            <div class="tab-l-content">
                <img src="@/assets/images/app.png" alt="">
            </div>
            <div class="tab-r-content">
                <h4>Title</h4>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem, totam suscipit. Necessitatibus odit odio facere facilis explicabo repellendus, nobis voluptate nisi veritatis omnis cupiditate maxime voluptatum illum rem modi ex!</p>
            </div>
        </div> -->
        <div class="tab">
            <div class="tab-l-content">
                <img src="@/assets/images/fibonacci.png" alt="">
            </div>
            <div class="tab-r-content">
                <p>Être vu c’est bien, être reconnu c’est mieux. Pour ce faire, les entreprises se doivent d’avoir une image graphique forte et cohérente</p>
                <p>En fonction des objectifs de communication, nous développons l'image de marque à  travers le concept, la créativité et un processus de ciblage efficace.</p>
                <ul>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Création de logo, carte de visite, flyer, etc...
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Webdesign, selon votre charte graphique ou sur mesure
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Motion design, animation, création 3D
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="tab">
            <div class="tab-l-content">
                <img src="@/assets/images/fibonacci.png" alt="">
            </div>
            <div class="tab-r-content">
                <h4>Title</h4>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem, totam suscipit. Necessitatibus odit odio facere facilis explicabo repellendus, nobis voluptate nisi veritatis omnis cupiditate maxime voluptatum illum rem modi ex!</p>
            </div>
        </div> -->
        <!-- <div class="tab">
            <div class="tab-l-content">
                <img src="@/assets/images/search.png" alt="">
            </div>
            <div class="tab-r-content">
                <h4>Title</h4>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem, totam suscipit. Necessitatibus odit odio facere facilis explicabo repellendus, nobis voluptate nisi veritatis omnis cupiditate maxime voluptatum illum rem modi ex!</p>
            </div>
        </div> -->
        <div class="tab" id="tab-360">
            <div class="tab-l-content">
                <iframe src="https://geneva-3d.com/autres/mdcies360/" style="width: 100%; height: 350px" frameborder="0"></iframe>

            </div>
            <div class="tab-r-content">
                <p>Avec la visite virtuelle, découvrez l'expérience la plus immersive pour visiter à distance tout type d'établissement.</p>
                <p>Visiter un hôtel-restaurant, une maison, un lieu de vacances, un commerce, vendre un bien immobilier, louer une résidence de vacances... La visite virtuelle est faite pour vous, faites découvrir votre bien par le simple partage d'un lien, dans un e-mail ou sur votre site internet.</p>
                <ul>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Nous nous déplaçons à votre adresse pour prendre des clichés en 360°.
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Différentes qualités de photos selon l'appareil utilisé et votre budget.
                    </li>
                    <li>
                        <i class="g3i g3i-carret-right"></i> Appliquation sur mesure pour votre site ou intégration google.
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import tab from '@/plugins/tabs.js'

export default {
    components: {
    },
    data() {
        return {      
        }
    },
    mounted () {
        tab.init('tab-nav');

    },
    methods: {

    },
}

</script>

<style lang='scss'>
#tab-nav{
    text-align: center;
    margin-bottom: 30px;
}
.tablink{
    cursor: pointer;
    font-family: $sub-title-font;
    padding: 6px 20px;
    font-size: 23px;
    color: $grey-text;
    border-bottom: 2px solid $grey-text;
    transition: .3s;
    &.active, &:hover{
        color: $main-color;
        border-bottom: 2px solid $main-color;
    }
    @include mq1024{
        display: inline-block;
        border-bottom: 0px;
        background-color: white;
        padding: 7px 15px;
        color: $content-black;
        margin: 5px;
        border-radius: 5px;
        &.active, &:hover{
            color: white;
            background-color: $main-color;
            border-bottom: 0px;
        }   
    }
}
.tab {
    display: none;
    opacity: 0;
    animation: hideTab .2s;
    & > div{
        width: 50%;
        padding: 30px 30px 0 30px;
        @include mq768{
            width: 100%;
        }
    }
    .tab-l-content > *{
        border-radius: 5px;
    }
    &#tab-360{
        .tab-l-content{
            width: 50%;
        }
        .tab-r-content{
            width: 50%;
        }
    }

    &.active{
        //animation-delay: .5s;
        animation: showTab .5s;
        display: flex;
        
        opacity: 1;
        @include mq768{
            flex-direction: column;
        }
        & > div{
            @include mq768{
                width: 100% !important;
                img{
                    max-width: 400px;
                    margin: 0 auto;
                    display: block;
                }
            }    
        }
    }
    p{
        color: $title-black;
        line-height: 19px;
        font-family: $link-font;
        font-size: 17px;
    }
    ul{
        margin-top: 30px;
        li{
            display: flex;
            font-family: $content-font;
            color: $content-black;
            font-size: 17px;
            margin-bottom: 15px;
            &:last-child{
                margin-bottom: 0;
            }
            .g3i{
                display: block;
                color: $main-color;
                font-size: 13px;
                margin-right: 10px;
                line-height: 18px;
            }
        }
    }
}

@keyframes showTab{
    0%{
        display: none;
        opacity: 0;
        transform: translateY(30px);
    }
    20%{
        display: none;
        opacity: 0;
        transform: translateY(30px);
    }
    100%{
        display: flex;
        opacity: 1;
        transform: translateY(0px);
    }
}

@keyframes hideTab{
    0%{
        display: flex;
        opacity: 1;
    }
    10%{
        display: flex;
        opacity: 1;
    }
    100%{
        display: none;
        opacity: 0;
    }
}

</style>